var PropagateUpdatesMethod = {
  Never: "never",
  Parent: "parent",
  Always: "always"
};
var TriggerEvent = {
  OnChange: "onChange",
  OnClear: "onClear",
  OnSet: "onSet",
  OnMatch: "onMatch"
};
var TriggerAction = {
  Change: "change",
  Clear: "clear",
  Set: "set"
};
var FormChangeSource = {
  Field: "field",
  Trigger: "trigger",
  Clearer: "clearer",
  Array: "array",
  Other: "other"
};

export { FormChangeSource, PropagateUpdatesMethod, TriggerAction, TriggerEvent };
